import { useState } from 'react'
import { sendFeedback } from '../api/settings'

const LIMIT = 4000

/**
 * A line to the people who wrote this.
 *
 * It lives in settings rather than on the website because that is where the
 * agent already is, already signed in. Nothing from the ticket goes with it:
 * the message, who sent it, and which help desk they work in is enough to act
 * on, and a customer's words are not ours to collect for our own benefit.
 */
export function FeedbackSection() {
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  async function send() {
    setBusy(true)
    setError('')
    try {
      await sendFeedback(message.trim())
      setMessage('')
      setSent(true)
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="card">
      <h2>Send feedback</h2>
      <p className="hint">What is working, what is not, what you wish it did.</p>

      {error && <div className="error">{error}</div>}

      <label className="field">
        <span>Your message</span>
        <textarea
          value={message}
          maxLength={LIMIT}
          placeholder="The drafts are too formal for our customers…"
          onChange={(e) => {
            setMessage(e.target.value)
            setSent(false)
          }}
        />
      </label>

      <button disabled={busy || !message.trim()} onClick={() => void send()}>
        {busy ? 'Sending…' : 'Send'}
      </button>

      {sent && <p className="note done">Thank you. We read every one.</p>}

      <p className="note">
        We cannot reply here. For an answer, write to support@orovim.com.
      </p>
    </div>
  )
}
